export enum ImageType {
  SPLASH_SCREEN = "SPLASH_SCREEN",
  PACK_IMAGE = "PACK_IMAGE",
  BANNER = "BANNER",
  NOTIFICATION = "NOTIFICATION",
  STORE_BANNER = "STORE_BANNER",
  CHALLENGE_REWARD_IMAGE = "CHALLENGE_REWARD_IMAGE",
}

export interface ImageDimensions {
  width: number;
  height: number;
  label: string;
  description: string;
}

export const DEFAULT_IMAGE_DIMENSIONS: Record<ImageType, ImageDimensions> = {
  [ImageType.SPLASH_SCREEN]: {
    width: 386,
    height: 616,
    label: "Splash Screen",
    description: "Portrait orientation",
  },
  [ImageType.PACK_IMAGE]: {
    width: 250,
    height: 400,
    label: "Pack Image",
    description: "Portrait orientation",
  },
  [ImageType.BANNER]: {
    width: 720,
    height: 203,
    label: "Banner",
    description: "Landscape orientation",
  },
  [ImageType.NOTIFICATION]: {
    width: 125,
    height: 200,
    label: "Notification",
    description: "Portrait orientation",
  },
  [ImageType.STORE_BANNER]: {
    width: 720,
    height: 202,
    label: "Store Banner",
    description: "Landscape orientation",
  },
  [ImageType.CHALLENGE_REWARD_IMAGE]: {
    width: 250,
    height: 400,
    label: "Challenge Reward Image",
    description: "Portrait orientation",
  },
};

export function calculateAspectRatioDimensions(
  originalWidth: number,
  originalHeight: number,
  newValue: number,
  changedDimension: "width" | "height",
): { width: number; height: number } {
  const aspectRatio = originalWidth / originalHeight;

  if (changedDimension === "width") {
    return {
      width: newValue,
      height: Math.round(newValue / aspectRatio),
    };
  } else {
    return {
      width: Math.round(newValue * aspectRatio),
      height: newValue,
    };
  }
}
